module.exports = __webpack_public_path__ + "static/assets/c6778106d615504de22e9254f1729577.svg";